<template>
  <draggable :list="items" group="people" class="tree">
    <div v-for="(node, index) in items" :key="node.id">
      <div class="tree-node">
        <a :href="'/baza-skladnikow?id=' + node.id" :class="{'bold': node['is_alergen']}">{{ node['name'] }}</a>
        <div class="tree-buttons">
          <button type="button" class="btn-close vs-chip--close" @click="removeChild(node, index)">
            <i class="vs-icon notranslate icon-scale material-icons null">clear</i>
          </button>
        </div>
      </div>
      <div v-if="node.children_ingredients" class="tree-children">
        <InternalIngredientsTree :items="node.children_ingredients" />
      </div>
    </div>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'internal-ingredients-tree',
  props: {
    items: {
      required: true,
      type: Array
    }
  },
  components: {
    draggable,
    InternalIngredientsTree: () => import('./InternalIngredientsTree.vue'),
  },
  methods: {
    removeChild: function (ing, index) {
      for (let i in this.items) {
        if (this.items[i].id === ing.id) {
          this.items.splice(i, 1);
        }
      }
    },
  },
}
</script>
<style scoped>
.tree {
  list-style-type: none;
  padding-left: 10px;
}

.tree-node {
  margin-bottom: 5px;
  border: 1px solid #ddd;
  padding: 5px 0 5px 5px;
  background-color: #f9f9f9;
  display: block;
}

.tree-children {
  padding-left: 20px;
}

.tree-buttons {
  float: right;
}

.bold {
  font-weight: bold;
}
</style>